import React from 'react';
import { ReCaptcha, loadReCaptcha } from 'react-recaptcha-v3'
import classnames from 'classnames';
import {Alert, Form, Icon, Input, Button, Select, Row, Col } from 'antd';
import get from 'lodash/get';

import { contactUsRequest } from "../../api/requests";

import classes from './ContactUsForm.css';
import { withNamespaces } from 'react-i18next';

const { Option } = Select;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class ContactUsForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      token: '',
    };
  }

  componentDidMount = () => {
    loadReCaptcha(process.env.REACT_APP_RECAPTCHA_SITE_KEY);
  };

  verifyCallback = (recaptchaToken) => {
    this.setState({token: recaptchaToken})
  }

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const payload = {...values};
          payload['recaptcha_response'] = this.state.token;

          const response = await contactUsRequest(payload);

          this.setState({ isLoading: false, requestResult: { type: 'success', message: get(response, 'data.message') } });
          setTimeout(() => {
            window.location.href = "/";
          }, 1500)
        } catch (e) {
          if (get(e, 'response.status') === 401) { this.props.logout();  return; }
          this.setState({ isLoading: false, requestResult: { type: 'error', message: get(e, 'response.data.message', this.props.i18n.t('Error')) } });

          if (get(e, 'response.data.errors')) {
            const errors = {};
            Object.keys(get(e, 'response.data.errors')).forEach(errorFieldKey => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(errorMessage => new Error(errorMessage))
              }
            });
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };


  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className='headline-default'>
            {this.props.i18n.t('Contact Us')}
          </h4>

          <p>
            {this.props.i18n.t('NamespaceContactUsForm:If you have any questions, you can send the Research Team a message below. Please enter your email address, a short subject, and a brief description of your inquiry.')} {this.props.i18n.t('NamespaceContactUsForm:Your message will be sent to')} <strong><a href="mailto:alex@diamindsolutions.ca" target="_blank">alex [at] diamindsolutions [dot] ca</a></strong>.
          </p>

          <p>{this.props.i18n.t('NamespaceContactUsForm:Regards,')}<br/> {this.props.i18n.t('NamespaceContactUsForm:The DCTMS Trial Team')}</p>

          <Row gutter={12}>
            {/*<Col span={12}>
              <label>
                <b>Name:</b>
                <Form.Item>
                  {getFieldDecorator('name', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'name', '')
                  })(
                    <Input placeholder='Name' />
                  )}
                </Form.Item>
              </label>
            </Col>*/}
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('Email')}:</b>
                <Form.Item>
                  {getFieldDecorator('email', {
                    rules: [{ required: true, message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'email', '')
                  })(
                    <Input type='email' placeholder='email' />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('Subject')}:</b>
                <Form.Item>
                  {getFieldDecorator('subject', {
                    rules: [{ required: true, message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'subject', '')
                  })(
                    <Input placeholder={this.props.i18n.t('Subject')} />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col>
              <label>
                <b>{this.props.i18n.t('Message')}:</b>
                <Form.Item>
                  {getFieldDecorator('message', {
                    rules: [{ required: true, message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'message', '')
                  })(
                    <Input.TextArea placeholder={this.props.i18n.t('Message')} />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <ReCaptcha
            ref={this.recaptcha}
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            action='contact_us'
            verifyCallback={this.verifyCallback}
          />

          {requestResult.type && (<div><Alert message={requestResult.message} type={requestResult.type} className={classes.submitResult} /><br/></div>)}

          <div className={classes.actionWrapper}>
            <Button type="primary" size="default" htmlType="submit" className={classnames(classes.submitButton, 'menu-item')}>
              {this.props.i18n.t('Send')}
              {isLoading && <Icon type="loading" />}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

export default Form.create({ name: 'user' })(withNamespaces()(ContactUsForm));



// WEBPACK FOOTER //
// ./src/components/ContactUsForm/ContactUsForm.js